export const copy = {
  errors: {
    addressLine1: 'Please enter an address.',
    city: 'Please enter a city.',
    postcode: 'Please enter a postcode comprised of 4 digits.',
  },
};
